import React from 'react'
import './App.css'
import { Routes, Route } from 'react-router-dom'
import Header from './components/Header/Header'
import AboutMe from './components/AboutMe/AboutMe'
import Name from './components/Name/Name'
import Resume from './components/Resume/Resume'
import TechStack from './components/TechStack/TechStack'
import Achivements from './components/Achivements/Achivements'
import BongocatGif from './components/BongoCatGif/BongocatGif'
import Projects from './components/Projects/Projects'
import Experience from './components/Experience/Experience'
import NavbarComponent from './components/Navbar/NavbarComponent'
import Footer from './components/Footer/Footer'
import FadeIn from './components/FadeIn/FadeIn'
import RestaurantMap from './components/foodmap/RestaurantMap'
import { SpeedInsights } from '@vercel/speed-insights/react';

const Portfolio = () => (
  <>
    <NavbarComponent/>
    <Header />
    <div className="Cover">
      <FadeIn>
        <div className="middle" id="about-me">
          <AboutMe />
          <Name />
        </div>
      </FadeIn>
      <FadeIn>
        <div className="middle" id="resume">
          <Resume />
          <TechStack />
        </div>
      </FadeIn>
      <FadeIn>
        <div className="middle" id="experience">
          <Experience />
        </div>
      </FadeIn>
      <FadeIn>
        <div className="middle" id="projects">
          <Projects />
        </div>
      </FadeIn>
      <FadeIn>
        <div className="middle" id="achievements">
          <Achivements />
          <BongocatGif />
        </div>
      </FadeIn>
      <Footer/>
    </div>
  </>
)

const App = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Portfolio />} />
        <Route path="/foodmap" element={<RestaurantMap />} />
      </Routes>
      <SpeedInsights />
    </>
  )
}

export default App
